import { render, staticRenderFns } from "./SystemMessageCell.vue?vue&type=template&id=cf901806&"
import script from "./SystemMessageCell.vue?vue&type=script&lang=js&"
export * from "./SystemMessageCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports